const styles = theme => ({
        container:{
            margin: "auto",
            overflowY: "auto",
            "&:disabled": {
                backgroundColor: '#d0d0d0'
            },
            minHeight: 'calc(100vh - 229px)'
        },
        tableHeader: {
            color: '#f7f6ff',
            fontFamily: 'AvenirNext',
            fontSize: '13px',
            fontWeight: 500,
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 'normal',
            letterSpacing: 'normal',
            backgroundColor: '#43415c',
            width: '150px'
        },
        action:{
            cursor: 'pointer'
        },
        headerToolTipLabelContainer: {
                width: 125
        },
        claim_status: {
            whiteSpace: 'nowrap',
        },
        claim_number: {
            whiteSpace: 'nowrap',
        },
        tooltip :{
            backgroundColor: '#f5f5f5'
        },
        dialog:{
            minWidth: 500,
        },
        close: {
            position: "absolute",
            right: theme.spacing(1),
            top: theme.spacing(1),
        },
        dialogContainer: {
            padding: theme.spacing(2, 3),
        },
        error: {
            color: 'red',
            textAlign: 'center',
        },
        header:{
            "textAlign": "left",
            "fontFamily": "'AvenirNext-Medium'",
            "fontSize": "18px",
            "fontWeight": "500",
            "color": "#3b3b3b",
            "padding": "10px 0 0 10px"
        },
        instructions: {
            fontFamily: "AvenirNext",
            fontSize: "15px",
        },
        secondaryInstructions: {
            width: "270px",
            height: "20px",
            margin: "10px 193px 24px 7px",
            fontFamily: "AvenirNext",
            fontSize: "15px",
            fontWeight: 500,
            fontStretch: "normal",
            fontStyle: "normal",
            lineHeight: "normal",
            letterSpacing: "normal",
            color: "#3b3b3b"
        },
        title:{
            textAlign: "left",
            fontFamily: "'AvenirNext-Medium'",
            fontSize: "18px",
            fontWeight: 500,
            color: "#3b3b3b",
            padding: "10px"
        },
        downloadReport:{
            "display": "flex",
            "justifyContent": "right",
        },
        alignRight:{
            "display": "flex",
            "justifyContent": "right",
        },
        textBlur: {
          color: 'transparent',
          textShadow: '0 0 10px rgba(0,0,0,0.6)',
        },
    }

);

export default styles;
